import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "BasketElement";
var classes = {
    image: "".concat(PREFIX, "-image"),
    cardContent: "".concat(PREFIX, "-cardContent"),
    actions: "".concat(PREFIX, "-actions")
};
var StyledBasketElement = styled(Card)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: "flex",
            backgroundColor: "transparent",
            boxShadow: "none",
            borderRadius: 0,
            cursor: "pointer",
            "&:hover, &:focus-within": {
                backgroundColor: theme.palette.background.paper
            }
        },
        _b["&:hover .".concat(classes.actions, ", &:focus-within .").concat(classes.actions)] = {
            opacity: 1
        },
        _b["& .".concat(classes.image)] = {
            cursor: "pointer",
            width: theme.spacing(12),
            height: theme.spacing(12),
            maxHeight: "14vh",
            maxWidth: "14vh",
            border: "none",
            position: "relative",
            objectFit: "cover",
            "&:focus": {
                filter: "brightness(0.8)"
            }
        },
        _b["& .".concat(classes.cardContent)] = {
            cursor: "default",
            position: "relative",
            flex: "1",
            padding: theme.spacing(1),
            wordBreak: "break-word"
        },
        _b["& .".concat(classes.actions)] = {
            position: "absolute",
            opacity: 0,
            transitionProperty: "opacity",
            transitionDuration: "0.1s",
            padding: theme.spacing(1),
            bottom: 0,
            right: 0
        },
        _b);
});

export { classes, StyledBasketElement as default };
//# sourceMappingURL=index.styled.js.map
